import React from 'react';
import { CreateSubcategoryState } from './createSubcategoryState/CreateSubcategoryState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const CreateSubcategoryPageV2: React.FC = () => {
	return (
		<CreateSubcategoryState>
			<Forms />
			<ModalWindows />
		</CreateSubcategoryState>
	);
};
